module.exports = __webpack_public_path__ + "img/white.e8fc6687.jpg";